var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 12,
    viewBox: "0 0 13 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.7191 5.46602C13.0129 5.75977 13.0129 6.23477 12.7191 6.52539L7.46914 11.7785C7.17539 12.0723 6.70039 12.0723 6.40977 11.7785C6.11914 11.4848 6.11602 11.0098 6.40977 10.7191L10.3785 6.74727H0.750391C0.334766 6.74727 0.000391006 6.41289 0.000391006 5.99727C0.000391006 5.58164 0.334766 5.24727 0.750391 5.24727H10.3785L6.40664 1.27852C6.11289 0.984767 6.11289 0.509767 6.40664 0.219142C6.70039 -0.0714828 7.17539 -0.0746078 7.46602 0.219142L12.7191 5.46602Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight);
export default __webpack_public_path__ + "static/media/arrow-right.dcea681755dd5cad12d17c4448046668.svg";
export { ForwardRef as ReactComponent };